export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 text-white py-32">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6">
            Consultancy Services
          </h1>
          <p className="text-xl leading-relaxed text-blue-50">
            Strategic guidance and expert advisory services to help your business navigate complex challenges, optimize operations, and achieve sustainable growth through data-driven insights and proven methodologies.
          </p>
        </div>
      </div>
    </section>
  );
}